/**
 * Storage keys shared between AuthContext and PersonalityContext.
 * Kept in a leaf module so neither context transitively imports the other.
 */

export const PERSONALITY_STORAGE_KEY = 'bva_personality_type';
